import SalesLedgerDayBookCriteriaModal from '../../components/modals/SalesLedgerDayBookCriteriaModal';
import { IWorkspaceAction } from '../../@types/workspaceTypes';
import React, { ReactElement, useState } from 'react';

enum SalesTransactionWorkspaceActions {
  SALES_DAYBOOK = 'Sales Daybook',
}

export const workspaceActionsForPermissions = [
  {
    actionReference: SalesTransactionWorkspaceActions.SALES_DAYBOOK,
  },
];

export const useSalesTransactionWorkspaceActions = (): [actions: Array<IWorkspaceAction>, modals: ReactElement] => {
  const [daybookOpen, setDaybookOpen] = useState(false);

  const actions: Array<IWorkspaceAction> = [
    {
      actionReference: SalesTransactionWorkspaceActions.SALES_DAYBOOK,
      key: 'sales_daybook',
      text: 'Sales Daybook',
      onClick: () => setDaybookOpen(true),
      ignoreBulkActionCheck: true, //This report does not use workspace selections.
    },
  ];

  return [
    actions,
    <>
      <SalesLedgerDayBookCriteriaModal isOpen={daybookOpen} onClose={() => setDaybookOpen(false)} />
    </>,
  ];
};
